import { Box, ThemeProvider } from '@mui/material';
import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import VerifyCode from '../components/VerifyCode';
import { config } from '../config';
import OverView from '../designer/account-settings/Dashboard';
import EasyWebinarsignUp from '../designer/easyWebinar-signUp/easyWebinar-signUp';
import EasysuiteWelcomeDashboard from '../designer/easysuiteWelcomeDashbord/EasysuiteWelcomeDashboard';
import SignupPage from '../designer/umbrella-signUp/signup-2026';
import UmbrellaSignUp from '../designer/umbrella-signUp/umbrella-signUp';
import CancellationFlow from '../designer/cancellation/Cancellation';
import EasywebinarLogin from '../pages/Archives/EasywebinarLogin';
import BlackFridayPricingPage from '../pages/BlackFridayPricingPage';
import Dashboard from '../pages/Dashboard';
import ForgotPassword from '../pages/ForgotPassword';
import LinkAccount from '../pages/LinkAccount';
import LoadingDashboard from '../pages/LoadingDashboard';
import Login from '../pages/Login';
import LoginOTP from '../pages/LoginOTP';
import Logout from '../pages/Logout';
import NotFound from '../pages/NotFound';
import PurchaseSuccess from '../pages/PurchaseSuccess';
import SSOSignup from '../pages/SSOSignup';
import SaleAnnual from '../pages/SaleAnnual';
import SaleLifetime from '../pages/SaleLifetime';
import SaleMonthly from '../pages/SaleMonthly';
import Signup from '../pages/signup';
import SignupFreePlan from '../pages/Signup-free-plan';
import SSOCallback from '../pages/SsoCallback';
import SuperAdmin from '../pages/SuperAdmin';
import Onboarding from '../pages/onboarding';
import WebinarconSignup from '../pages/Webinarcon-Signup/SalesExperienceSignup';
import SalesExperienceSignupB from '../pages/Webinarcon-Signup/SalesExperienceSignupB';
import SignupSales14DayTrial from '../pages/Webinarcon-Signup/Signup14DayTrial';
import SignupSales14DayTrialWithBook from '../pages/Webinarcon-Signup/Signup14DayTrialWithBook';
import SignupSales30DayTrialWithBook from '../pages/Webinarcon-Signup/Signup30DayTrialWithBook';
import WorkshopBundleAnnual from '../pages/WorkshopBundleAnnual';
import WorkshopBundleLifetime from '../pages/WorkshopBundleLifetime';
import theme from '../theme';
import ProtectedRoute from './ProtectedRoute';
import RedirectIfAuthenticated from './RedirectIfAuthenticated';
import Signup2ndFlow from '../pages/Signup2ndFlow';
import SignupWithoutPayment from '../pages/SignupWithoutPayment';
import SignupVerifyEmail from '../pages/SignupVerifyEmail';
import AilaunchLogin from '../pages/AILogin';
import ForgotPasswordAilaunch from '../pages/AIForgotPassword';
import TryAiFlowPricingPage from '../pages/Ai-lauch-plan/pricing/page';
import TryAiFlowPaymentPage from '../pages/Ai-lauch-plan/payment/page';
import TryAiFlowSignupPage from '../pages/Ai-lauch-plan/auth/page';
import TryAiFlowCreatePasswordPage from '../pages/Ai-lauch-plan/auth/create-password/page';
import TryAiFlowEmailVerificationPage from '../pages/Ai-lauch-plan/auth/email-verification/page';
import TryAiFlowLoginPage from '../pages/Ai-lauch-plan/auth/login/page';
import TryAiFlowForgotPasswordPage from '../pages/Ai-lauch-plan/auth/forgot-password/page';
import TryAiFlowForgotPasswordVerifyPage from '../pages/Ai-lauch-plan/auth/forgot-password/verify/page';

// Dynamic Signup Component
const DynamicSignup: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get saleVersion from query parameter first, then localStorage, default to 'true'
  const querySaleVersion = searchParams.get('saleVersion');
  const storedSaleVersion = localStorage.getItem('saleVersion');
  const saleVersion = querySaleVersion || storedSaleVersion || 'true';
  
  useEffect(() => {
    // Always update localStorage with current saleVersion
    localStorage.setItem('saleVersion', saleVersion);
  }, [saleVersion]);
  
  // Show sale version if config.isSaleLive is true AND saleVersion is 'true'
  const shouldShowSale = config.isSaleLive && saleVersion === 'true';
  
  //return shouldShowSale ? <SignupSale /> : <Signup />;
  return <Signup />;

};

// Dynamic SignupFlowSale Component
const DynamicSignupFlowSale: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get saleVersion from query parameter first, then localStorage, default to 'true'
  const querySaleVersion = searchParams.get('saleVersion');
  const storedSaleVersion = localStorage.getItem('saleVersion');
  const saleVersion = querySaleVersion || storedSaleVersion || 'true';
  
  useEffect(() => {
    // Always update localStorage with current saleVersion
    localStorage.setItem('saleVersion', saleVersion);
  }, [saleVersion]);
  
  // Show sale version if config.isSaleLive is true AND saleVersion is 'true'
  const shouldShowSale = config.isSaleLive && saleVersion === 'true';
  
  //return shouldShowSale ? <SignupSale /> : <Signup />;
  return <Signup2ndFlow />;
};

// Dynamic Login Component
const DynamicLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get saleVersion from query parameter first, then localStorage, default to 'true'
  const querySaleVersion = searchParams.get('saleVersion');
  const storedSaleVersion = localStorage.getItem('saleVersion');
  const saleVersion = querySaleVersion || storedSaleVersion || 'true';
  
  useEffect(() => {
    // Always update localStorage with current saleVersion
    localStorage.setItem('saleVersion', saleVersion);
  }, [saleVersion]);
  
  // Show sale version if config.isSaleLive is true AND saleVersion is 'true'
  const shouldShowSale = config.isSaleLive && saleVersion === 'true';
  
  //return shouldShowSale ? <LoginSale /> : <Login />;
  return <Login />;
};

// Dynamic SSO Signup Component
const DynamicSSOSignup: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get saleVersion from query parameter first, then localStorage, default to 'true'
  const querySaleVersion = searchParams.get('saleVersion');
  const storedSaleVersion = localStorage.getItem('saleVersion');
  const saleVersion = querySaleVersion || storedSaleVersion || 'true';
  
  useEffect(() => {
    // Always update localStorage with current saleVersion
    localStorage.setItem('saleVersion', saleVersion);
  }, [saleVersion]);
  
  // Show sale version if config.isSaleLive is true AND saleVersion is 'true'
  const shouldShowSale = config.isSaleLive && saleVersion === 'true';
  
  //return shouldShowSale ? <SSOSignupSale /> : <SSOSignup />;
  return <SSOSignup />;
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route 
        path="/ew-login" 
        element={
          <RedirectIfAuthenticated>
            <EasywebinarLogin />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/login" 
        element={
          <RedirectIfAuthenticated>
            <DynamicLogin />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/login-support" 
        element={
          <RedirectIfAuthenticated>
            <LoginOTP />
          </RedirectIfAuthenticated>
        } 
      />
      <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <ThemeProvider theme={theme}><Box sx={{ 
                '& .MuiTypography-root': {
                  fontFamily: "'Roboto', sans-serif"
                }
              }}><Dashboard /></Box></ThemeProvider>
            </ProtectedRoute>
          }
      />
      <Route 
        path="/signup" 
        element={
          <RedirectIfAuthenticated>
            <DynamicSignup />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/signup-flow" 
        element={
          <RedirectIfAuthenticated>
            <DynamicSignupFlowSale />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/loading-dashboard" 
        element={
            <LoadingDashboard />
        } 
      />
      <Route 
        path="/link-account" 
        element={
            <LinkAccount />
        } 
      />
      <Route path="/logout" element={<Logout />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-code" element={<VerifyCode />} />
      <Route 
        path="/sso-signup" 
        element={
            <DynamicSSOSignup />
        } 
      />
      <Route path="/auth/sso/callback" element={<SSOCallback />} />
      <Route path="/designer">
        <Route path="login" element={<Login />} />
        <Route path="umbrellaSignUp" element={<UmbrellaSignUp />} />
        <Route path="SignupPage" element={<SignupPage />} />
        <Route path="easyWebinarSignUp" element={<EasyWebinarsignUp />} />
        <Route path="dashboard" element={<OverView />} />
        <Route path="cancellation" element={<CancellationFlow />} />
        <Route path="easysuite-dashboard" element={<EasysuiteWelcomeDashboard />} />
      </Route>
      <Route 
        path="/super-admin" 
        element={
          <ProtectedRoute>
            <ThemeProvider theme={theme}>
              <Box sx={{ 
                '& .MuiTypography-root': {
                  fontFamily: "'Roboto', sans-serif"
                }
              }}>
                <SuperAdmin />
              </Box>
            </ThemeProvider>
          </ProtectedRoute>
        } 
      />
     

      <Route 
        path="/signup-free-plan" 
        element={
          <RedirectIfAuthenticated>
            <SignupFreePlan/>
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/signup-ai-flow" 
        element={
          <RedirectIfAuthenticated>
            <SignupWithoutPayment />
          </RedirectIfAuthenticated>
        } 
      />
      <Route path="/signup-verify-email" element={<SignupVerifyEmail />} />
      <Route 
        path="/login-ai-flow" 
        element={
          <RedirectIfAuthenticated>
            <AilaunchLogin />
          </RedirectIfAuthenticated>
        } 
      />
      <Route path="/forgot-password-ailaunch" element={<ForgotPasswordAilaunch />} />

      <Route 
        path="/sales-experience-signup" 
        element={
          <RedirectIfAuthenticated>
            <WebinarconSignup/>
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/sales-experience-signup-b" 
        element={
          <RedirectIfAuthenticated>
            <SalesExperienceSignupB/>
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/signup-30" 
        element={
          <RedirectIfAuthenticated>
            <SignupSales30DayTrialWithBook />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/signup-14" 
        element={
          <RedirectIfAuthenticated>
            <SignupSales14DayTrialWithBook />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/signup-14-trial" 
        element={
          <RedirectIfAuthenticated>
            <SignupSales14DayTrial />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/onboarding" 
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        } 
      />

      <Route path="/try-ai-flow/pricing" element={<TryAiFlowPricingPage />} />
      <Route path="/try-ai-flow/payment" element={<TryAiFlowPaymentPage />} />
      <Route path="/try-ai-flow/auth" element={<TryAiFlowSignupPage />} />
      <Route path="/try-ai-flow/auth/login" element={<TryAiFlowLoginPage />} />
      <Route path="/try-ai-flow/auth/forgot-password" element={<TryAiFlowForgotPasswordPage />} />
      <Route path="/try-ai-flow/auth/forgot-password/verify" element={<TryAiFlowForgotPasswordVerifyPage />} />
      <Route path="/try-ai-flow/auth/create-password" element={<TryAiFlowCreatePasswordPage />} />
      <Route path="/try-ai-flow/auth/email-verification" element={<TryAiFlowEmailVerificationPage />} />

      <Route 
        path="/holiday-sale-annual" 
        element={
          <RedirectIfAuthenticated>
            <SaleAnnual/>
          </RedirectIfAuthenticated>
        } 
      />

      <Route 
        path="/holiday-sale-lifetime" 
        element={
          <RedirectIfAuthenticated>
            <SaleLifetime/>
          </RedirectIfAuthenticated>
        } 
      />

      <Route 
        path="/holiday-sale-monthly" 
        element={
          <RedirectIfAuthenticated>
            <SaleMonthly/>
          </RedirectIfAuthenticated>
        } 
      />

      <Route 
        path="/workshop-bundle-annual" 
        element={
          <RedirectIfAuthenticated>
            <WorkshopBundleAnnual/>
          </RedirectIfAuthenticated>
        } 
      />

      <Route 
        path="/workshop-bundle-lifetime" 
        element={
          <RedirectIfAuthenticated>
            <WorkshopBundleLifetime/>
          </RedirectIfAuthenticated>
        } 
      />

      <Route 
        path="/black-friday-pricing" 
        element={
          <ProtectedRoute>
            <ThemeProvider theme={theme}>
              <Box sx={{ 
                '& .MuiTypography-root': {
                  fontFamily: "'Roboto', sans-serif"
                }
              }}>
                <BlackFridayPricingPage/>
              </Box>
            </ThemeProvider>
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/purchase-success" 
        element={<PurchaseSuccess />} 
      />

      {/* Catch-all route for 404 page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;